export enum FormLabelModifier {
  SMALL = 'form-label--small',
  BIG = 'form-label--big',
  DROPZONE = 'form-label--dropzone',
  // to be found in _form-checkbox.scss
  SWITCH = 'form-label--switch',
  CHECKBOX = 'form-label--checkbox',
  // to be found in _form-radio.scss
  RADIO = 'radio',
  CHECKBOX_MULTISELECT = 'form-label--checkbox-multiselect',
  VERTICAL_ALIGN = 'vertical-align',
  HIDDEN = 'hidden',
  POSITION_INHERIT = 'position-inherit',
}

export enum FormLabelContainerModifier {
  NO_MARGIN = 'no-margin-bottom', // standard for checkboxes
  DISABLED = 'disabled',
  FLEX100 = 'flex100',
  FLEX = 'flex',
  DROPZONE = 'dropzone',
}
